import { PageData, ActSummary, ChapterSummary, TOTAL_PAGES, NOVEL_AUTHOR, NOVEL_TITLE, clampPageNumber } from '../../types/tome';
import { FRONT_MATTER_PAGES } from './frontMatter';
import { ACT_1_PAGES } from './act1';
import { ACT_2_PAGES } from './act2';
import { ACT_3_PAGES } from './act3';
import { ACT_4_PAGES } from './act4';
import { ACT_5_PAGES } from './act5';
import { ACT_6_PAGES } from './act6';
import { ACT_7_PAGES } from './act7';
import { ACT_8_PAGES } from './act8';
import { ACT_9_PAGES } from './act9';
import { ACT_10_PAGES } from './act10';
import { APPENDICES_PAGES } from './appendices';

export const ACT_DEFINITIONS: ActSummary[] = [
  {
    "actNumber": 0,
    "title": "Front Matter & Pre-Flight Handshake",
    "startPage": 1,
    "endPage": 7,
    "chapterCount": 1,
    "description": "System authentication, vessel schematics, author dedication, and liability waivers."
  },
  {
    "actNumber": 1,
    "title": "Act I: The Discrete Universe",
    "startPage": 8,
    "endPage": 45,
    "chapterCount": 4,
    "description": "Superconducting coils at idle, Marcus Ward's tremors, and routine transitions across Perseus Gate."
  },
  {
    "actNumber": 2,
    "title": "Act II: The Widening Seam",
    "startPage": 46,
    "endPage": 93,
    "chapterCount": 4,
    "description": "Entry into the Great Null Rift, stasis hang, Elena's override, and cargo bay omission anomalies."
  },
  {
    "actNumber": 3,
    "title": "Act III: The Stillness That Breathes",
    "startPage": 94,
    "endPage": 151,
    "chapterCount": 4,
    "description": "Core containment blowout, marooned inside the zero-time Planck gap, and the silence of non-being."
  },
  {
    "actNumber": 4,
    "title": "Act IV: The Spectators in the Margin",
    "startPage": 152,
    "endPage": 205,
    "chapterCount": 4,
    "description": "Direct encounters with the geometric entities in the cosmic ledger who watch while the universe pauses."
  },
  {
    "actNumber": 5,
    "title": "Act V: The Necrosis of Sequence",
    "startPage": 206,
    "endPage": 247,
    "chapterCount": 4,
    "description": "Synaptic decay, chronognostic aphasia, memories bleeding from future coordinates, and flesh as an address."
  },
  {
    "actNumber": 6,
    "title": "Act VI: The Cosmic Ledger Overwrite",
    "startPage": 248,
    "endPage": 293,
    "chapterCount": 4,
    "description": "Manual coordinate rewiring, compiler garbage collection protocols, and missing mass reconciliations."
  },
  {
    "actNumber": 7,
    "title": "Act VII: The Autopsy of Time",
    "startPage": 294,
    "endPage": 333,
    "chapterCount": 4,
    "description": "Deconstructing the Geryon into pure numerical parameters to squeeze through the unrendered interval."
  },
  {
    "actNumber": 8,
    "title": "Act VIII: The Ignition of the Next Moment",
    "startPage": 334,
    "endPage": 369,
    "chapterCount": 4,
    "description": "The terrifying sacrifice to strike the next Planck tick, lighting the fire of physical reality."
  },
  {
    "actNumber": 9,
    "title": "Act IX: The Phantom Shore",
    "startPage": 370,
    "endPage": 401,
    "chapterCount": 4,
    "description": "Re-crystallizing light-years away, altered physical constants, and the realization that the crew returned changed."
  },
  {
    "actNumber": 10,
    "title": "Act X: The Quarantine of Marcus Ward",
    "startPage": 402,
    "endPage": 428,
    "chapterCount": 3,
    "description": "Station Perseus-Theta convalescence, corporate tribunal debriefs, and permanent sight into the margin."
  },
  {
    "actNumber": 11,
    "title": "Codex Appendices & Classified Archives",
    "startPage": 429,
    "endPage": 452,
    "chapterCount": 5,
    "description": "Full mathematical treatise, DSM-Chrono complete pathology tables, lost ship manifests, and terminal colophon."
  }
];

export const CHAPTER_DEFINITIONS: ChapterSummary[] = [
  {
    "chapterNumber": 0,
    "actNumber": 0,
    "title": "Pre-Flight Disclaimers & Schematics",
    "startPage": 1,
    "endPage": 7,
    "pageCount": 7,
    "contentArchetype": "technical"
  },
  {
    "chapterNumber": 1,
    "actNumber": 1,
    "title": "Chapter 1: The Tick and the Void",
    "startPage": 8,
    "endPage": 17,
    "pageCount": 10,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 2,
    "actNumber": 1,
    "title": "Chapter 2: The Scent of Ozone and Burnt Copper",
    "startPage": 18,
    "endPage": 27,
    "pageCount": 10,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 3,
    "actNumber": 1,
    "title": "Chapter 3: Retinal After-Images of Non-Space",
    "startPage": 28,
    "endPage": 36,
    "pageCount": 9,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 4,
    "actNumber": 1,
    "title": "Chapter 4: The Sound the Hull Makes When Time Stops",
    "startPage": 37,
    "endPage": 45,
    "pageCount": 9,
    "contentArchetype": "log"
  },
  {
    "chapterNumber": 5,
    "actNumber": 2,
    "title": "Chapter 5: Entry into the Great Null Rift",
    "startPage": 46,
    "endPage": 57,
    "pageCount": 12,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 6,
    "actNumber": 2,
    "title": "Chapter 6: Three Seconds in the Margin",
    "startPage": 58,
    "endPage": 69,
    "pageCount": 12,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 7,
    "actNumber": 2,
    "title": "Chapter 7: The Unrendered Room",
    "startPage": 70,
    "endPage": 81,
    "pageCount": 12,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 8,
    "actNumber": 2,
    "title": "Chapter 8: The Necrosis of Sequence",
    "startPage": 82,
    "endPage": 93,
    "pageCount": 12,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 9,
    "actNumber": 3,
    "title": "Chapter 9: Core Containment Blowout",
    "startPage": 94,
    "endPage": 108,
    "pageCount": 15,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 10,
    "actNumber": 3,
    "title": "Chapter 10: Walking the Uncoupled Spine",
    "startPage": 109,
    "endPage": 122,
    "pageCount": 14,
    "contentArchetype": "log"
  },
  {
    "chapterNumber": 11,
    "actNumber": 3,
    "title": "Chapter 11: The Stillness That Breathes",
    "startPage": 123,
    "endPage": 137,
    "pageCount": 15,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 12,
    "actNumber": 3,
    "title": "Chapter 12: Frozen Light and Cold Coordinates",
    "startPage": 138,
    "endPage": 151,
    "pageCount": 14,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 13,
    "actNumber": 4,
    "title": "Chapter 13: The Observers in the Gutter",
    "startPage": 152,
    "endPage": 165,
    "pageCount": 14,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 14,
    "actNumber": 4,
    "title": "Chapter 14: The Architecture of Omission",
    "startPage": 166,
    "endPage": 178,
    "pageCount": 13,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 15,
    "actNumber": 4,
    "title": "Chapter 15: Elena's Communion",
    "startPage": 179,
    "endPage": 192,
    "pageCount": 14,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 16,
    "actNumber": 4,
    "title": "Chapter 16: The Cost of Observation",
    "startPage": 193,
    "endPage": 205,
    "pageCount": 13,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 17,
    "actNumber": 5,
    "title": "Chapter 17: Memories of Tomorrow",
    "startPage": 206,
    "endPage": 216,
    "pageCount": 11,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 18,
    "actNumber": 5,
    "title": "Chapter 18: The Dissolution of Speech",
    "startPage": 217,
    "endPage": 226,
    "pageCount": 10,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 19,
    "actNumber": 5,
    "title": "Chapter 19: The Clinical Descent of Marcus Ward",
    "startPage": 227,
    "endPage": 237,
    "pageCount": 11,
    "contentArchetype": "clinical"
  },
  {
    "chapterNumber": 20,
    "actNumber": 5,
    "title": "Chapter 20: The Flesh as an Address",
    "startPage": 238,
    "endPage": 247,
    "pageCount": 10,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 21,
    "actNumber": 6,
    "title": "Chapter 21: Cracking the Cosmic Ledger",
    "startPage": 248,
    "endPage": 259,
    "pageCount": 12,
    "contentArchetype": "ledger"
  },
  {
    "chapterNumber": 22,
    "actNumber": 6,
    "title": "Chapter 22: The Missing Mass Audit",
    "startPage": 260,
    "endPage": 270,
    "pageCount": 11,
    "contentArchetype": "ledger"
  },
  {
    "chapterNumber": 23,
    "actNumber": 6,
    "title": "Chapter 23: Elena's Final Calculus",
    "startPage": 271,
    "endPage": 282,
    "pageCount": 12,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 24,
    "actNumber": 6,
    "title": "Chapter 24: The Garbage Collector",
    "startPage": 283,
    "endPage": 293,
    "pageCount": 11,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 25,
    "actNumber": 7,
    "title": "Chapter 25: Stripping the Keel",
    "startPage": 294,
    "endPage": 303,
    "pageCount": 10,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 26,
    "actNumber": 7,
    "title": "Chapter 26: The Niobium Sacraments",
    "startPage": 304,
    "endPage": 313,
    "pageCount": 10,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 27,
    "actNumber": 7,
    "title": "Chapter 27: Blood in the Magnetic Cradle",
    "startPage": 314,
    "endPage": 323,
    "pageCount": 10,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 28,
    "actNumber": 7,
    "title": "Chapter 28: The Reduction to Pure Syntax",
    "startPage": 324,
    "endPage": 333,
    "pageCount": 10,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 29,
    "actNumber": 8,
    "title": "Chapter 29: Striking the Spark",
    "startPage": 334,
    "endPage": 342,
    "pageCount": 9,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 30,
    "actNumber": 8,
    "title": "Chapter 30: When the Next Moment Catches Fire",
    "startPage": 343,
    "endPage": 351,
    "pageCount": 9,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 31,
    "actNumber": 8,
    "title": "Chapter 31: The Shear of Re-Crystallization",
    "startPage": 352,
    "endPage": 360,
    "pageCount": 9,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 32,
    "actNumber": 8,
    "title": "Chapter 32: The Sound of Spacetime Healing",
    "startPage": 361,
    "endPage": 369,
    "pageCount": 9,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 33,
    "actNumber": 9,
    "title": "Chapter 33: Emergence at Perseus Rim",
    "startPage": 370,
    "endPage": 377,
    "pageCount": 8,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 34,
    "actNumber": 9,
    "title": "Chapter 34: The Cargo Bay That Was Not",
    "startPage": 378,
    "endPage": 385,
    "pageCount": 8,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 35,
    "actNumber": 9,
    "title": "Chapter 35: Elena's Absent Shadow",
    "startPage": 386,
    "endPage": 393,
    "pageCount": 8,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 36,
    "actNumber": 9,
    "title": "Chapter 36: Distorted Constants",
    "startPage": 394,
    "endPage": 401,
    "pageCount": 8,
    "contentArchetype": "technical"
  },
  {
    "chapterNumber": 37,
    "actNumber": 10,
    "title": "Chapter 37: Automated Salvage Tether",
    "startPage": 402,
    "endPage": 410,
    "pageCount": 9,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 38,
    "actNumber": 10,
    "title": "Chapter 38: The Inquest of Thorne-Vance",
    "startPage": 411,
    "endPage": 419,
    "pageCount": 9,
    "contentArchetype": "clinical"
  },
  {
    "chapterNumber": 39,
    "actNumber": 10,
    "title": "Chapter 39: The Gaze from the Margin",
    "startPage": 420,
    "endPage": 428,
    "pageCount": 9,
    "contentArchetype": "narrative"
  },
  {
    "chapterNumber": 40,
    "actNumber": 11,
    "title": "Appendix A: Mathematics of the Discrete Interval",
    "startPage": 429,
    "endPage": 433,
    "pageCount": 5,
    "contentArchetype": "codex"
  },
  {
    "chapterNumber": 41,
    "actNumber": 11,
    "title": "Appendix B: Thorne-Vance Classified Inquest Files",
    "startPage": 434,
    "endPage": 438,
    "pageCount": 5,
    "contentArchetype": "codex"
  },
  {
    "chapterNumber": 42,
    "actNumber": 11,
    "title": "Appendix C: Complete DSM-Chrono VII Taxonomy",
    "startPage": 439,
    "endPage": 443,
    "pageCount": 5,
    "contentArchetype": "codex"
  },
  {
    "chapterNumber": 43,
    "actNumber": 11,
    "title": "Appendix D: Cosmic Ledger Lost Hull Concordance",
    "startPage": 444,
    "endPage": 448,
    "pageCount": 5,
    "contentArchetype": "codex"
  },
  {
    "chapterNumber": 44,
    "actNumber": 11,
    "title": "Appendix E: Engineering Schematics & Terminal Colophon",
    "startPage": 449,
    "endPage": 452,
    "pageCount": 4,
    "contentArchetype": "codex"
  }
];

export const ALL_PAGES: PageData[] = [
  ...FRONT_MATTER_PAGES,
  ...ACT_1_PAGES,
  ...ACT_2_PAGES,
  ...ACT_3_PAGES,
  ...ACT_4_PAGES,
  ...ACT_5_PAGES,
  ...ACT_6_PAGES,
  ...ACT_7_PAGES,
  ...ACT_8_PAGES,
  ...ACT_9_PAGES,
  ...ACT_10_PAGES,
  ...APPENDICES_PAGES,
];

export function getPage(pageNumber: number): PageData {
  const clamped = clampPageNumber(pageNumber);
  return ALL_PAGES[clamped - 1];
}

export function getAllPages(): PageData[] {
  return ALL_PAGES;
}

export function getActs(): ActSummary[] {
  return [...ACT_DEFINITIONS];
}

export function getChapters(): ChapterSummary[] {
  return [...CHAPTER_DEFINITIONS];
}

export { TOTAL_PAGES, NOVEL_AUTHOR, NOVEL_TITLE };
